import { API_URL } from '../constants/index'
import { getRequest, postRequest, getcontractIdNumber } from './api'

// export async function list(size, index, searchTerm, orderBy) {
//   return getRequest(`proposal/get-list/${size || 10}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
// }

export async function list(
  size,
  index,
  orderBy,
  orderNumber,
  proposalNumber,
  beginDate,
  endDate,
  status,
) {
  const url = new URL(`${API_URL}proposal/get-filters`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  const contractID = getcontractIdNumber()

  if (contractID !== 0) {
    searchParams.append('contractID', contractID)
  }

  if (size !== null && size !== undefined) {
    searchParams.append('size', parseInt(size, 10) || 15)
  }

  if (index !== null && index !== undefined) {
    searchParams.append('index', parseInt(index, 10) || 0)
  }

  if (orderBy !== null && orderBy !== undefined) {
    searchParams.append('orderBy', orderBy)
  }

  if (orderNumber !== null && orderNumber !== undefined) {
    searchParams.append('orderNumber', orderNumber)
  }

  if (proposalNumber !== null && proposalNumber !== undefined) {
    searchParams.append('proposalNumber', proposalNumber)
  }

  if (beginDate !== null && beginDate !== undefined) {
    searchParams.append('beginDate', beginDate)
  }

  if (endDate !== null && endDate !== undefined) {
    searchParams.append('endDate', endDate)
  }

  if (status !== null && status !== undefined) {
    searchParams.append('status', status)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function listForApprovement(
  size,
  index,
  orderBy,
  orderNumber,
  proposalNumber,
  beginDate,
  endDate,
  status,
) {
  const url = new URL(`${API_URL}proposal/approvementlist/get-filters`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  const contractID = getcontractIdNumber()

  if (contractID !== 0) {
    searchParams.append('contractID', contractID)
  }

  if (size !== null && size !== undefined) {
    searchParams.append('size', parseInt(size, 10) || 15)
  }

  if (index !== null && index !== undefined) {
    searchParams.append('index', parseInt(index, 10) || 0)
  }

  if (orderBy !== null && orderBy !== undefined) {
    searchParams.append('orderBy', orderBy)
  }

  if (orderNumber !== null && orderNumber !== undefined) {
    searchParams.append('orderNumber', orderNumber)
  }

  if (proposalNumber !== null && proposalNumber !== undefined) {
    searchParams.append('proposalNumber', proposalNumber)
  }

  if (beginDate !== null && beginDate !== undefined) {
    searchParams.append('beginDate', beginDate)
  }

  if (endDate !== null && endDate !== undefined) {
    searchParams.append('endDate', endDate)
  }

  if (status !== null && status !== undefined) {
    searchParams.append('status', status)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function find(id) {
  return getRequest(`proposal/edit/${id}`)
}

export async function findForPreview(id) {
  return getRequest(`proposal/editForPreview/${id}`)
}

export async function copy(id) {
  return getRequest(`proposal/copy/${id}`)
}

export async function save(values) {
  return postRequest(`proposal/save`, values)
}

export function remove(values) {
  return postRequest(`proposal/delete`, values)
}

export async function create() {
  const ContractID = getcontractIdNumber()
  return getRequest(`proposal/create/${ContractID}`)
}

// PROTEC-951: status changes with comments, newest first
export async function statusHistory(id) {
  return getRequest(`proposal/status-history/${id}`)
}

export async function createWorkOrder(id) {
  return getRequest(`workOrder/create-from-proposal/${id}`)
}

export async function getCostView(id) {
  return getRequest(`proposal/get-cost-view/${id}`)
}

export async function sendToApprovement(id) {
  const data = {
    values: {
      id,
    },
  }

  return postRequest(`proposal/sendToApprovement`, data)
}

export async function approveProposal(id, approvedComment) {
  const data = {
    values: {
      id,
      approvedComment,
    },
  }

  return postRequest(`proposal/approve`, data)
}

export async function setProposalOverBudget(id) {
  const data = {
    values: {
      id,
    },
  }
  return postRequest('proposal/set-over-budget', data)
}

export async function rejectProposal(id, rejectReason) {
  const data = {
    values: {
      id,
      rejectReason,
    },
  }

  return postRequest(`proposal/reject`, data)
}

export async function cancelProposal(id) {
  const data = {
    values: {
      id,
    },
  }

  return postRequest(`proposal/cancel`, data)
}

export async function createCustomerProposalRequest(proposalData) {
  return postRequest(`proposal/create-customer-request`, proposalData)
}

export async function getMyProposals(createdByUserID, size = 10, index = 0, contractId = null, customerEmail = null) {
  const url = new URL(`${API_URL}proposal/get-my-proposals`)
  const searchParams = new URLSearchParams()
  searchParams.append('createdByUserID', createdByUserID)
  searchParams.append('size', size)
  searchParams.append('index', index)
  if (contractId) {
    searchParams.append('contractId', contractId)
  }
  if (customerEmail) {
    searchParams.append('customerEmail', customerEmail)
  }
  url.search = searchParams.toString()
  return getRequest(url.toString())
}

export async function getPendingProposalsTotal() {
  try {
    // list params: (size, index, orderBy, orderNumber, proposalNumber, beginDate, endDate, status)
    // status 1 = Pending
    const result = await list(9999, 0, null, null, null, null, null, 1)
    if (result && result.items) {
      const total = result.items.reduce((sum, p) => sum + (p.totalNetto || 0), 0)
      return { total, count: result.items.length }
    }
    return { total: 0, count: 0 }
  } catch (e) {
    console.error('Failed to get pending proposals total:', e)
    return { total: 0, count: 0 }
  }
}

export async function getSuperiorApprover(contractId, proposalAmount, excludeUserId) {
  try {
    const result = await getRequest(`proposal/get-superior-approver?contractId=${contractId}&proposalAmount=${proposalAmount}&excludeUserId=${excludeUserId}`)
    return result
  } catch (e) {
    return { found: false, name: null }
  }
}

export async function getCustomerApprovementList(customerEmail, size = 10, index = 0, contractId = null, customerUserID = null, budgetApprovalLimit = null) {
  const url = new URL(`${API_URL}proposal/get-customer-approvement-list`)
  const searchParams = new URLSearchParams()
  if (customerEmail) {
    searchParams.append('customerEmail', customerEmail)
  }
  searchParams.append('size', size)
  searchParams.append('index', index)
  if (contractId) {
    searchParams.append('contractId', contractId)
  }
  if (customerUserID) {
    searchParams.append('customerUserID', customerUserID)
  }
  if (budgetApprovalLimit) {
    searchParams.append('budgetApprovalLimit', budgetApprovalLimit)
  }
  url.search = searchParams.toString()
  return getRequest(url.toString())
}
